import { useQuery } from "@tanstack/react-query";
import ApiSink from "../api/sink";

const apiSink = new ApiSink();

export interface DownloadItem {
  id: string;
  date: string;
  label: string;
  survey_ids: number[];
}

export function useDownloads(surveyId: number | null) {
  const query = useQuery({
    queryKey: ["downloads", surveyId],
    queryFn: async () => {
      if (!surveyId) return [];
      const response = await apiSink.getDownloads(surveyId);
      if (response.error) {
        console.error(
          `Failed to fetch downloads for survey ${surveyId}:`,
          response.message || response.error
        );
        return []; // Treat errors as empty downloads (no downloads available)
      }
      return response;
    },
    enabled: surveyId !== null,
    staleTime: 1000 * 60, // 60 seconds
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    downloads: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
